import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash',
    routes: [
        {
            path: '/login',
            component: () => import('@/pages/Login.vue'),
        },
        {
            path: '/signup',
            component: () => import('@/pages/Signup.vue'),
        },
        {
            path: '/reset-password',
            component: () => import('@/pages/ResetPassword.vue'),
        },
        {
            path: '/personal-info',
            component: () => import('@/pages/PersonalInfo.vue'),
            meta: {
                layout: 'empty',
            },
        },
        {
            path: '/security-info',
            component: () => import('@/pages/SecurityInfo.vue'),
            meta: {
                removePartials: true,
            },
        },
        {
            path: '/not-allowed',
            component: () => import('@/pages/NotAllowed.vue'),
            meta: {
                removePartials: true,
                layout: 'empty',
            },
        },
        {
            path: '*',
            redirect: '/login',
        },
    ],
});

// router.beforeEach((to, from, next) => {
//     const loggedIn = localStorage.getItem('authenticated')

//     console.log(loggedIn, 'loggedIn')

//     if (to.matched.some(path => path.meta.requiresAuth)) {
//         if (!loggedIn) {
//             next('/auth/login')
//         } else {
//             next()
//         }
//     } else {
//         next()
//     }
// })

export default router;
